











































































import { Vue, Component, Watch, Prop, Emit } from 'vue-property-decorator';
import AMSUpload from '../components/AMSUpload.vue';
import AMSTable, { ITableHeader } from '../components/AMSTable.vue';
import TestEditor from './TestEditor.vue';
import { AppStore } from '@/store/modules/app';
import { PaginationModel } from '../components/AMSPagination.vue';
// @ts-ignore
import Treeselect from '@riophae/vue-treeselect';
import '@riophae/vue-treeselect/dist/vue-treeselect.css';
import AMSDialog from '@/components/AMSDialog.vue';
import AMSProductCategorySelector from '@/components/AMSProductCategorySelector.vue';
import AMSStaffSelector from '@/components/AMSStaffSelector.vue';
import AMSProductSelector from '@/components/AMSProductSelector.vue';
import AMSBrandSelector from '@/components/AMSBrandSelector.vue';

@Component({
  components: {
    'ams-table': AMSTable,
    'ams-upload': AMSUpload,
    'ams-editor': TestEditor,
    treeselect: Treeselect,
    'ams-dialog': AMSDialog,
    'ams-product-category-selector': AMSProductCategorySelector,
    'ams-staff-selector': AMSStaffSelector,
    'ams-product-selector': AMSProductSelector,
    'ams-brand-selector': AMSBrandSelector
  }
})
export default class TestTable extends Vue {
  dialogTitle: string = '客户等级';
  dialogWidth: number = 500;
  showDialog: boolean = false;
  headers = [];
  // headers: ITableHeader[] = [
  //   //headers表头数组，里面是对象
  //   <ITableHeader>{ text: '类型', align: 'center', value: 'type', width: '200px' },
  //   <ITableHeader>{ text: '名称', align: 'center', value: 'quantity', width: '200px', edit: true },
  //   <ITableHeader>{ text: '操作人', align: 'center', value: 'operator', width: '120px' },
  //   <ITableHeader>{ text: '入库时间', align: 'center', value: 'stockTime', width: '800px' }
  // ];
  items = [];
  searchName = '';
  dialog: boolean = false;
  newItemName: string = 'Add Item';
  api: string = '/mk_booklist'; //tableapi
  expand: boolean = true;
  uploadApi: string = '/mk_fileupload';
  accept: string = 'image/* .xlsx';
  multiple: boolean = false;
  editorValue: string = '<h1>111</h1>'; //编辑器
  routerhref: string = 'testEditor';
  value = null;
  options = [
    {
      id: 'a',
      label: 'a',
      children: [
        {
          id: 'aa',
          label: 'aa'
        },
        {
          id: 'ab',
          label: 'ab'
        }
      ]
    },
    {
      id: 'b',
      label: 'b'
    },
    {
      id: 'c',
      label: 'c'
    }
  ];

  /**选中商品分类 */
  categoryId: string = '';
  staff: any = {};
  product: Array<any> = [];
  brand: any = {};

  /**禁用的分类 */
  disableCategorys: any[] = ['df539444-5bac-42fe-8756-f5ede0f0d868'];

  onBrandValidate() {
    if ((this.$refs.brandForm as any).validate()) {
      AppStore.ShowSuccess('已选择品牌');
    } else {
      AppStore.ShowError('没有选择品牌');
    }
  }

  get brandRules() {
    console.log(this.brand);
    if (Object.keys(this.brand).length === 0) {
      const rule = (v: any) => {
        return '请选择品牌';
      };
      return [rule];
    } else {
      return [];
    }
  }

  get productRules() {
    if (this.product.length === 0) {
      const rule = (v: any) => {
        return '请选择商品';
      };
      return [rule];
    } else {
      return [];
    }
  }

  onProductValidate() {
    console.log('选择商品:');
    console.log(this.product);
    if ((this.$refs.productForm as any).validate()) {
      AppStore.ShowSuccess('已选择商品');
    } else {
      AppStore.ShowError('没有选择商品');
    }
  }

  get staffRules() {
    if (Object.keys(this.staff).length === 0) {
      const rule = (v: any) => {
        return '请选择员工';
      };
      return [rule];
    } else {
      return [];
    }
  }

  get categoryRules() {
    if (this.categoryId == undefined || this.categoryId == '') {
      const rule = (v: any) => {
        return '请选择商品分类';
      };
      return [rule];
    } else {
      return [];
    }
  }

  onStaffValidate() {
    if ((this.$refs.staffForm as any).validate()) {
      AppStore.ShowSuccess('已选择员工');
    } else {
      AppStore.ShowError('没有选择员工');
    }
  }

  /**验证是否选择了商品分类 */
  onCategoryValidate() {
    // this.disableCategorys.push('c7e827d7-d594-44d7-a286-fa76ae12a41c');
    // this.disableCategorys.push('aa18d414-4f92-449a-a079-329e1e6b28d6');
    // this.disableCategorys.push('724b310f-9c9d-47d3-b131-20cee11601b0');
    this.categoryId = 'c7e827d7-d594-44d7-a286-fa76ae12a41c';

    if ((this.$refs.productCategoryForm as any).validate()) {
      AppStore.ShowSuccess('已选择商品分类');
    } else {
      AppStore.ShowError('没有选择商品分类');
    }
  }

  /**显示ams-dialog */
  showAMSDialog() {
    this.showDialog = true;
  }
  closeAMSDialog() {
    this.showDialog = false;
  }
  submitAMSDialog() {
    this.showDialog = false;
  }

  show() {
    this.dialog = true;
    this.newItemName = 'Add Item';
  }
  saveAll(): void {
    AppStore.ShowSuccess('保存成功');
  }
  deleteAll() {
    AppStore.ShowError(' 该商品已经关联了7个商品，不可删除！');
  }
  showModal(record?: { type: string; item: object } | undefined) {
    this.dialog = true;
    this.newItemName = 'Edit Item';
  }
  close() {
    this.dialog = false;
  }
  save() {}

  getEditorContent() {
    console.log('编辑器内容:', this.editorValue);
  }
}
